'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _regeneratorRuntime = _interopDefault(require('babel-runtime/regenerator'));
var _asyncToGenerator = _interopDefault(require('babel-runtime/helpers/asyncToGenerator'));
var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));

var emit = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type) {
    var _this = this;

    var listeners,
        onceListeners,
        _len,
        args,
        _key,
        i,
        event,
        rlt,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            assertType(type);
            listeners = this.listeners(type);
            onceListeners = [];

            if (!(listeners && listeners.length)) {
              _context.next = 18;
              break;
            }

            for (_len = _args.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = _args[_key];
            }

            i = 0;

          case 6:
            if (!(i < listeners.length)) {
              _context.next = 16;
              break;
            }

            event = listeners[i];
            rlt = event.apply(this, args);

            if (!isPromise(rlt)) {
              _context.next = 12;
              break;
            }

            _context.next = 12;
            return rlt;

          case 12:
            if (this._events[type][i][TYPE_KEYNAME] === 'once') {
              onceListeners.push(event);
            }

          case 13:
            i++;
            _context.next = 6;
            break;

          case 16:
            onceListeners.forEach(function (event) {
              return _this.removeListener(type, event);
            });

            return _context.abrupt('return', true);

          case 18:
            return _context.abrupt('return', false);

          case 19:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function emit(_x) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * @file: AwaitEventEmitter
 * @author: Cuttle Cong
 * @date: 2017/11/1
 * @description:
 */
var isPromise = require('is-promise');
var TYPE_KEYNAME = typeof Symbol === 'function' ? Symbol('--[[await-event-emitter]]--') : '--[[await-event-emitter]]--';

function assertType(type) {
  if (typeof type !== 'string' && (typeof type === 'undefined' ? 'undefined' : _typeof(type)) !== 'symbol') {
    throw new TypeError('type is not type of string or symbol!');
  }
}

function assertFn(fn) {
  if (typeof fn !== 'function') {
    throw new TypeError('fn is not type of Function!');
  }
}

function alwaysListener(fn) {
  var _ref;

  return _ref = {}, _ref[TYPE_KEYNAME] = 'always', _ref.fn = fn, _ref;
}
function onceListener(fn) {
  var _ref2;

  return _ref2 = {}, _ref2[TYPE_KEYNAME] = 'once', _ref2.fn = fn, _ref2;
}

function AwaitEventEmitter() {
  this._events = {};
}

function on(type, fn) {
  assertType(type);
  assertFn(fn);
  this._events[type] = this._events[type] || [];
  this._events[type].push(alwaysListener(fn));
  return this;
}

function prepend(type, fn) {
  assertType(type);
  assertFn(fn);
  this._events[type] = this._events[type] || [];
  this._events[type].unshift(alwaysListener(fn));
  return this;
}

function prependOnce(type, fn) {
  assertType(type);
  assertFn(fn);
  this._events[type] = this._events[type] || [];
  this._events[type].unshift(onceListener(fn));
  return this;
}

function listeners(type) {
  return (this._events[type] || []).map(function (x) {
    return x.fn;
  });
}

function once(type, fn) {
  assertType(type);
  assertFn(fn);
  this._events[type] = this._events[type] || [];
  this._events[type].push(onceListener(fn));
  return this;
}

function removeListener(type, nullOrFn) {
  assertType(type);

  var listeners = this.listeners(type);
  if (typeof nullOrFn === 'function') {
    var index = void 0,
        found = false;
    while ((index = listeners.indexOf(nullOrFn)) >= 0) {
      listeners.splice(index, 1);
      this._events[type].splice(index, 1);
      found = true;
    }
    return found;
  } else {
    return delete this._events[type];
  }
}

function emitSync(type) {
  var _this2 = this;

  assertType(type);
  var listeners = this.listeners(type);
  var onceListeners = [];
  if (listeners && listeners.length) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    for (var i = 0; i < listeners.length; i++) {
      var event = listeners[i];
      event.apply(this, args);

      if (this._events[type][i][TYPE_KEYNAME] === 'once') {
        onceListeners.push(event);
      }
    }
    onceListeners.forEach(function (event) {
      return _this2.removeListener(type, event);
    });

    return true;
  }
  return false;
}

AwaitEventEmitter.prototype.on = AwaitEventEmitter.prototype.addListener = on;
AwaitEventEmitter.prototype.once = once;
AwaitEventEmitter.prototype.prependListener = prepend;
AwaitEventEmitter.prototype.prependOnceListener = prependOnce;
AwaitEventEmitter.prototype.off = AwaitEventEmitter.prototype.removeListener = removeListener;
AwaitEventEmitter.prototype.emit = emit;
AwaitEventEmitter.prototype.emitSync = emitSync;
AwaitEventEmitter.prototype.listeners = listeners;

if (typeof module !== 'undefined') {
  module.exports = AwaitEventEmitter;
}



// WEBPACK FOOTER //
// ./~/await-event-emitter/index.es5.js